import React, {Component} from 'react';
import firebase from 'firebase';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Eye } from 'react-preloading-component';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';


function rankFormatter(cell, row, rowIndex, formatExtraData) {
    return (
        <div>
            {cell>=0.0&& cell<0.5 &&
            <div>
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
            </div>
            }

            {cell>=0.5 && cell<1.5 &&
            <div>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
            </div>
            }

            {cell>=1.5 && cell<2.5 &&
            <div>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
            </div>
            }
            {cell>=2.5 && cell<3.5 &&
            <div>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                <i className={ formatExtraData[cell] } />
                <i className={ formatExtraData[cell] } />
            </div>
            }
            {cell>=3.5 && cell<4.5 &&
                <div>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <i className={ formatExtraData[cell] } />
                </div>
            }
            {cell>=4.5 &&
                <div>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                    <span style={{color:'#ffd741'}}><i className={ formatExtraData[cell] } ></i></span>
                </div>
            }
            
      </div>
    );
  }



export default class ReportCali extends Component{
    constructor(props){
        super(props);
        this.state={califica:[], nombreC:[], isLoading:false  ,rowStyle2:[]  };
    }

    componentWillMount = () =>{
        firebase.database().ref('/Votos').once('value').then(snap =>{
            let empleA = [];
            snap.forEach(element => {
                let dato = element.val();
                firebase.database().ref('/Empleados/'+element.key).once('value').then(snapE=>{
                    let emple = snapE.val();
                    try{
                    dato.nombre = emple.nombre.toLowerCase();
                    firebase.database().ref('/Calificaciones').once('value').then(snapC=>{
                        snapC.forEach(elementC => {
                            let datosC = elementC.val();
                            let valor = (dato[elementC.key]===0)? 0:(dato[elementC.key]/dato.nViaje)
                            dato[datosC.pregunta] = valor.toFixed(1);

                        });
                        empleA.push(dato);
                        this.setState({califica:empleA});
                    });
                }catch(e){
                    console.log(e);
                }
                });
            
            });
           
            
        });
        
        firebase.database().ref('/Calificaciones').once('value').then(snapC=>{
            let nombreCA = [];
            nombreCA.push({ dataField: 'nombre', text: 'nombre',sort: true,filter: textFilter(),});
            snapC.forEach(elementC => {
                let datosC = elementC.val();

                nombreCA.push({ dataField: `${datosC.pregunta}`, text: `${datosC.pregunta}`,sort: true,
                align: 'center',
                filter: textFilter(),
                formatter: rankFormatter,
                formatExtraData: {
                    '0.0': 'fa fa-star',
                    '0.1': 'fa fa-star',
                    '0.2': 'fa fa-star',
                    '0.5': 'fa fa-star',
                    '0.4': 'fa fa-star',
                    '0.5': 'fa fa-star',
                    '0.6': 'fa fa-star',
                    '0.7': 'fa fa-star',
                    '0.8': 'fa fa-star',
                    '0.9': 'fa fa-star',
                    '1.0': 'fa fa-star',
                    '1.1': 'fa fa-star',
                    '1.2': 'fa fa-star',
                    '1.3': 'fa fa-star',
                    '1.4': 'fa fa-star',
                    '1.5': 'fa fa-star',
                    '1.6': 'fa fa-star',
                    '1.7': 'fa fa-star',
                    '1.8': 'fa fa-star',
                    '1.9': 'fa fa-star',
                    '2.0': 'fa fa-star',
                    '2.1': 'fa fa-star',
                    '2.2': 'fa fa-star',
                    '2.3': 'fa fa-star',
                    '2.4': 'fa fa-star',
                    '2.5': 'fa fa-star',
                    '2.6': 'fa fa-star',
                    '2.7': 'fa fa-star',
                    '2.8': 'fa fa-star',
                    '2.9': 'fa fa-star',
                    '3.0': 'fa fa-star',
                    '3.1': 'fa fa-star',
                    '3.2': 'fa fa-star',
                    '3.3': 'fa fa-star',
                    '3.4': 'fa fa-star',
                    '3.5': 'fa fa-star',
                    '3.6': 'fa fa-star',
                    '3.7': 'fa fa-star',
                    '3.8': 'fa fa-star',
                    '3.9': 'fa fa-star',
                    '4.0': 'fa fa-star',
                    '4.1': 'fa fa-star',
                    '4.2': 'fa fa-star',
                    '4.3': 'fa fa-star',
                    '4.4': 'fa fa-star',
                    '4.5': 'fa fa-star',
                    '4.6': 'fa fa-star',
                    '4.7': 'fa fa-star',
                    '4.8': 'fa fa-star',
                    '4.9': 'fa fa-star',
                    '5.0': 'fa fa-star',
              },
            });
            })    
            this.setState({nombreC:nombreCA, isLoading:true})
        })
    }
    

    render(){
        return(
        <div>
            {this.state.isLoading &&
            <BootstrapTable keyField='id' data={ this.state.califica } columns={ this.state.nombreC } striped
            hover
            condensed pagination={ paginationFactory() }  filter={ filterFactory() }/>
            }
            {!this.state.isLoading && 
					<div>
					<Eye
					color="#FF4601" 
					size={20} 
				  />
				  	
					</div>
					}
        </div>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteCalificacionGlobal.js